/**
 * Hero slider (sections/hero-slider.liquid).
 *
 * Slides share one grid cell and crossfade via the .is-active class. Autoplay
 * loops and pauses on hover, while focus is inside the carousel, when the
 * carousel is off-screen, and entirely under prefers-reduced-motion. Inactive
 * slides are aria-hidden + inert so their links can't be focused. Supports
 * dots, prev/next, a >40px horizontal swipe, and Left/Right arrow keys.
 */
(function () {
  'use strict';

  var SWIPE_MIN = 40;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function setup(root) {
    if (root._heroSlider) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hs-dot]'));
    var count = root.querySelector('[data-hs-count]');
    var prev = root.querySelector('[data-hs-prev]');
    var next = root.querySelector('[data-hs-next]');
    var n = slides.length;
    if (n < 2) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;

    var activeIndex = 0;
    var timer = null;
    var hovered = false;
    var focused = false;
    var visible = true;
    var editorLocked = false;
    var touchStartX = null;
    var touchStartY = null;

    function go(i) {
      activeIndex = ((i % n) + n) % n;
      slides.forEach(function (slide, idx) {
        var on = idx === activeIndex;
        slide.classList.toggle('is-active', on);
        if (on) {
          slide.removeAttribute('aria-hidden');
          slide.inert = false;
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.inert = true;
          slide.setAttribute('inert', '');
        }
      });
      dots.forEach(function (dot, idx) {
        var on = idx === activeIndex;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (count) count.textContent = pad(activeIndex + 1) + ' / ' + pad(n);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function sync() {
      var shouldRun = autoplay && !hovered && !focused && visible && !editorLocked;
      if (shouldRun && !timer) {
        timer = setInterval(function () { go(activeIndex + 1); }, interval);
      } else if (!shouldRun) {
        stop();
      }
    }

    /* Manual navigation restarts the countdown so the new slide gets a full interval. */
    function userGo(i) {
      go(i);
      stop();
      sync();
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        userGo(parseInt(dot.getAttribute('data-hs-dot'), 10) || 0);
      });
    });
    if (prev) prev.addEventListener('click', function () { userGo(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { userGo(activeIndex + 1); });

    root.addEventListener('mouseenter', function () { hovered = true; sync(); });
    root.addEventListener('mouseleave', function () { hovered = false; sync(); });
    root.addEventListener('focusin', function () { focused = true; sync(); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) { focused = false; sync(); }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); userGo(activeIndex - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); userGo(activeIndex + 1); }
    });

    root.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      touchStartX = t.clientX;
      touchStartY = t.clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - touchStartX;
      var dy = t.clientY - touchStartY;
      touchStartX = null;
      /* Horizontal swipes only, so vertical page scrolling never changes slides. */
      if (Math.abs(dx) > SWIPE_MIN && Math.abs(dx) > Math.abs(dy)) {
        userGo(dx < 0 ? activeIndex + 1 : activeIndex - 1);
      }
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.2 }).observe(root);
    }

    root._heroSlider = {
      goTo: function (i) { go(i); },
      lock: function (on) { editorLocked = on; sync(); },
      destroy: stop
    };

    go(0);
    sync();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-hero-slider]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme editor: re-init on section reload; jump to and hold a selected slide. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-hero-slider]');
    if (root && root._heroSlider) root._heroSlider.destroy();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-hs-slide]');
    var root = e.target.closest('[data-hero-slider]');
    if (!slide || !root || !root._heroSlider) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-slide]'));
    root._heroSlider.lock(true);
    root._heroSlider.goTo(slides.indexOf(slide));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest('[data-hero-slider]');
    if (root && root._heroSlider) root._heroSlider.lock(false);
  });
})();
